'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');
const tagManagement = require('../modules/utils/tag_management.utils');
var postBookingUtils = require('../modules/utils/post_booking.utils');
var postBookingSeatsCollection = require('../modules/collections/seatmap_preferences_selections.collection').getInstance();
var postBookingPayment = require('../modules/models/post_booking_payment.model').getInstance();
var url = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('addSeats');
const ecommerceUrl = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('getSeatsEcommerceData');

var responseToEventError = {
    CC_ERR: 'purchasePaymentError',
    PAY_ERR: 'purchasePaymentError',
    SEAT_SEL_ERR: 'purchaseError',
    VAL_ERR: 'purchaseError',
    UPDATE_WNG: 'purchaseOk',
    PROV_WNG: 'purchaseOk',
};

var errorTypeForTracking = {
    INVALID_CARD_NUMBER: 'cccard_number_submit_invalid_error',
    WRONG_CVV2: 'cccard_cvv_submit_invalid_error',
    WRONG_CREDITCARD_EXPIRATION_DATE: 'cccard_expiration_submit_invalid_errors',
    CARD_EXPIRED: 'cccard_expiration_submit_invalid_errors',
    DATA_VALIDATION_ERROR: 'cccard_owner_submit_invalid_error',
    UNKNOWN: 'other',
};


function hasAvailableSeats(ancillaryInfo) {
    if (!Odigeo._.has(ancillaryInfo, 'availableAncillariesOptionsDTO.collectionMethods') ||
        Odigeo._.isEmpty(Odigeo._.filter(ancillaryInfo.availableAncillariesOptionsDTO.collectionMethods, {collectionMethodType: 'CREDITCARD'}))) {
        return false;
    }

    if (Odigeo._.has(ancillaryInfo, 'availableAncillariesOptionsDTO.ancillaryOptionsContainer.seatMapResultsResponse') &&
        !Odigeo._.isEmpty(ancillaryInfo.availableAncillariesOptionsDTO.ancillaryOptionsContainer.seatMapResultsResponse)) {
        var seatMapResults = ancillaryInfo.availableAncillariesOptionsDTO.ancillaryOptionsContainer.seatMapResultsResponse;

        return Odigeo._.some(seatMapResults, function(seatMapResult) {
            return Odigeo._.some(seatMapResult.seatMapPreferencesDescriptorItemList, function(seatMapPreferenceDescriptor) {
                if (Odigeo._.isEmpty(seatMapPreferenceDescriptor.cabin)) {
                    return false;
                }
                return Odigeo._.some(seatMapPreferenceDescriptor.cabin, function(cabin) {
                    return !Odigeo._.isEmpty(cabin.seats);
                });
            });
        });
    }

    return false;
}

module.exports = {
    modelClass: require('../modules/models/post_booking_bags_and_seats.model'),

    // initialization
    init: function() {
        this.bindEvents();
    },

    bindEvents: function() {
        this.listenTo(postBookingSeatsCollection, 'add', this.seatsCollectionChanged);
        this.listenTo(postBookingSeatsCollection, 'remove', this.seatsCollectionChanged);
        this.view.listenTo(this.model, 'change:phase', this.view.render);
        postBookingUtils.hideOneClickCheckoutOnShoppingPhase(this.view.oneClickCheckoutContainer,
            this, this.model.phases.SHOPPING, Odigeo.AB.isOneClickCheckout);
    },

    //
    // handlers
    //
    seatsCollectionChanged: function() {
        var current = this.model.get('phase');
        var next = current;
        if (!this.hasSelectedAnySeat() || Odigeo.AB.isOneClickCheckout) {
            next = this.model.phases.SHOPPING;
        } else if (current === this.model.phases.SHOPPING) {
            next = this.model.phases.CHECKOUT;
        }
        this.model.set('phase', next);

        if (current === next) {
            this.view.render();
        }
    },

    //
    // public methods
    //

    clearSeatSelections: function() {
        postBookingSeatsCollection.reset();
    },

    checkAvailableSeats: function(ancillaryInfo) {
        var message = hasAvailableSeats(ancillaryInfo) ? 'seatsAvailable' : 'noSeatsAvailable';

        Odigeo.trigger(this.id + ':' + message, ancillaryInfo);
    },

    showAddSeats: function(bookingInfo, ancillaryInfo, showFlightInfo) {
        this.model.loadInfo(bookingInfo, ancillaryInfo, showFlightInfo);
        this.model.set('phase', this.model.phases.SHOPPING);
        postBookingUtils.initOneClickCheckout(this.view.oneClickCheckoutContainer,
            bookingInfo, Odigeo.AB.isOneClickCheckout);
    },

    changePhase: function(phase) {
        this.model.set('phase', Odigeo._.get(this.model.phases, phase, 'FAILURE'));
    },

    scrollTop: function() {
        this.view.scrollToTop();
    },

    showSuccess: function() {
        this.model.set('phase', this.model.phases.SUCCESS);
    },

    showPaymentFailure: function() {
        this.model.set('phase', this.model.phases.PAYMENT_FAILURE);
    },

    showFailure: function() {
        this.model.set('phase', this.model.phases.FAILURE);
    },

    open: function() {
        this.model.initialize();
        this.view.isOpen = true;
        this.view.open();
        this.trackPage('add');
    },

    close: function() {
        this.view.isOpen = false;
        this.view.close();
    },

    moveToPayment() {
        this.view.moveToPayment();
    },

    getTotalPrice: function() {
        return postBookingSeatsCollection.getTotalPrice();
    },

    getCurrencyConfig: function() {
        return Odigeo.Utils.Currency;
    },

    getTotalSeats: function() {
        return Odigeo._.size(postBookingSeatsCollection);
    },

    getPriceBreakdown: function() {
        return postBookingSeatsCollection.getPriceBreakdown();
    },

    hasSelectedAnySeat: function() {
        return postBookingSeatsCollection.hasSelectedAnySeat();
    },

    isPaymentMethodValid: function() {
        return this.model.get('paymentMethodValid');
    },

    isAcceptedCreditCardType: function() {
        var collectionMethods = postBookingUtils.getCollectionMethods(this.model.get('ancillaryInfo'));
        var creditCardTypeCode = this.model.get('creditCardTypeCode');
        return postBookingUtils.isAcceptedCreditCardType(collectionMethods, creditCardTypeCode);
    },

    allowPurchase: function() {
        return this.isPaymentMethodValid() && this.isAcceptedCreditCardType();
    },

    onCheckoutConfirm() {
        this.trackCheckoutEvent('seats_offline_add', 'seats_offline_click_pay_success');
        this.trackPage('confirmation');
        this.requestEcommerceData();
        this.view.onCheckoutConfirm();
    },

    requestEcommerceData: function() {
        const data = this.buildAddAncillariesRequest(postBookingSeatsCollection, postBookingPayment);
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            url: ecommerceUrl + '/' + this.model.getBookingId(),
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.ecommerceRequestSuccessHandler, this),
            timeout: 60000,
        });
    },

    ecommerceRequestSuccessHandler: function(response) {
        trackingUtils.trackEcommerce(response, 'postBookingAncillaries');
    },

    onCheckoutPaymentRetry() {
        this.trackCheckoutEvent('seats_offline_add', 'seats_offline_click_pay_error');
        this.trackPage('confirmation_error');
        this.view.onCheckoutPaymentRetry();
    },

    onCheckoutInteractionNeeded() {
        this.trackCheckoutEvent('seats_offline_add', 'seats_offline_click_pay_interaction');
        this.trackPage('interaction_needed');
        this.view.onCheckoutInteractionNeeded();
    },

    setCardData: function(isValid, paymentDetails) {
        this.model.set('paymentMethodValid', isValid);
        if (Odigeo.AB.isOneClickCheckout) {
            this.view.oneClickCheckoutContainer.execute('setCardData', paymentDetails);
        }
        postBookingPayment.set('paymentDetails', paymentDetails);
        this.view.render();
    },

    setCreditCardTypeCode: function(creditCardTypeCode, creditCardTypeName) {
        this.model.set({
            creditCardTypeCode: creditCardTypeCode,
            creditCardTypeName: creditCardTypeName,
        });
        if (Odigeo.AB.isOneClickCheckout) {
            this.view.oneClickCheckoutContainer.execute('setCreditCardTypeCode', creditCardTypeCode);
        }
        this.view.render();
    },

    buildAncillarySelectionList(seatsSelection) {
        const buildSeatSelectionRequest = function(seatSelection) {
            const seatFee = seatSelection.totalPrice - seatSelection.providerPrice;
            return {
                seatMapRow: seatSelection.seatMapRow,
                column: seatSelection.columnSelection,
                row: seatSelection.rowSelection,
                floor: seatSelection.floorSelection,
                section: seatSelection.section,
                totalPrice: {
                    amount: seatSelection.totalPrice.toFixed(2),
                    currencyCode: seatSelection.currencyCode,
                },
                seatFee: {
                    amount: seatFee.toFixed(2),
                    currencyCode: seatSelection.currencyCode,
                },
            };
        };
        const buildTravelerSeatsSelectionRequest = function(travelerIndex, travelerSeatsSelection) {
            const seatsSelectionRequest = Odigeo._.map(travelerSeatsSelection, buildSeatSelectionRequest);
            return {
                travellerNumber: travelerIndex,
                seatMapSelectionList: seatsSelectionRequest,
            };
        };

        const seatsSelectionByTraveler = Odigeo._.groupBy(seatsSelection.toJSON(), 'numPassenger');

        return Odigeo._.reduce(seatsSelectionByTraveler, function(acc, travelerSeatsSelection, travelerIndex) {
            acc.push(buildTravelerSeatsSelectionRequest(travelerIndex, travelerSeatsSelection));
            return acc;
        }, []);
    },

    buildAddAncillariesRequest: function(seatsSelection, postBookingPayment) {
        const creditCardDetails = postBookingPayment.get('paymentDetails').creditCardDetails;
        const seatsByTravelerRequest = this.buildAncillarySelectionList(seatsSelection);
        return {
            ancillarySelectionList: seatsByTravelerRequest,
            chargeBookingRequest: {
                amount: {
                    amount: seatsSelection.getTotalPrice().toFixed(2),
                    currencyCode: seatsSelection.getCurrencyCode(),
                },
                collectionCurrency: seatsSelection.getCurrencyCode(),
                collectionParameters: {
                    creditCardCollectionParameters: {
                        typeInfo: 'creditCardCollectionParameters',
                        typeCode: creditCardDetails.typeCode,
                        owner: creditCardDetails.owner,
                        number: creditCardDetails.number,
                        expiryDate: creditCardDetails.expirationMonth + creditCardDetails.expirationYear,
                        cvv2: creditCardDetails.securityNumber,
                    },
                },
            },
        };
    },

    purchaseSeats: function() {
        const data = this.buildAddAncillariesRequest(postBookingSeatsCollection, postBookingPayment);
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            url: url + '/' + this.model.getBookingId(),
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
            complete: Odigeo._.bind(this.clearSeatSelections, this),
            timeout: 60000,
        });
    },

    requestSuccessHandler: function(response) {
        if (!Odigeo._.isEmpty(response.errors)) {
            var error = response.errors[0];
            this.requestTracking(response);
            Odigeo.trigger(this.id + ':purchaseError', 'seats', error.message);
        } else {
            var res = response.addAncillariesResponseDTO;
            this.requestTracking(res);
            if (res.success) {
                trackingUtils.trackEcommerce(response.analyticsEcommerce, 'postBookingAncillaries');
                this.trackPage('confirmation', Odigeo._.get(response.analyticsEcommerce, 'transactionUniversal.id'));
                Odigeo.trigger(this.id + ':purchaseOk', 'seats');
            } else {
                this.trackPage('confirmation_error');
                Odigeo.trigger(this.id + ':' + (responseToEventError[res.code] || 'purchaseError'), 'seats');
            }
        }
    },

    onCloseAircraftMapTracking: function() {
        const isCheckin = Odigeo.Session.get('isCheckin') === 'true';
        if (!isCheckin) {
            this.trackPage('summary');
        }
    },

    trackPage(page, bookingIdWithTimestamp) {
        trackingUtils.trackPage('PB/seat/' + page, {
            funnel: false,
        });
        this.trackPageTMS(page, bookingIdWithTimestamp);
    },

    trackPageTMS(page, bookingIdWithTimestamp) {
        const selectionTrackingData = this.getSelectionTrackingData(page);
        const dataLayer = {
            ancillariesInfo: {
                ancil_seat_price: selectionTrackingData.seat_total_price,
                ancil_seat_quantity: selectionTrackingData.seat_quantity,
            },
            transactionInfo: {
                transaction_price: selectionTrackingData.seat_total_price,
                transaction_id: bookingIdWithTimestamp,
            },
        };
        tagManagement.updateAndExtendDatalayer(dataLayer, {
            page_name: page,
            product: 'seat_post_booking',
        });
    },

    getSelectionTrackingData(page) {
        return {
            seat_total_price: page !== 'add' ? postBookingSeatsCollection.getTotalPrice().toString() : null,
            seat_quantity: page !== 'add' ? postBookingSeatsCollection.getSelectedSeatsLength().toString() : null,
        };
    },

    requestTracking: function(response) {
        var label = 'success_';
        var result = 'OK';
        var errorMsg = response.message;
        if (!response.success) {
            label = response.code === 'PROV_WNG' || response.code === 'UPDATE_WNG' ? 'success_' : 'fail_';
            result = response.code === 'PAY_ERR' && Odigeo._.find(errorTypeForTracking, function(errorType, errorCode) {
                return Odigeo._.contains(errorMsg, errorCode);
            });
            result = result || (response.code === 'PROV_WNG' ? 'manual' : response.code === 'UPDATE_WNG' ? 'robot' : 'other');
        }
        trackingUtils.trackEventWithCategory(
            'my_area_trips_details',
            'seats_offline_add',
            'seats_offline_click_pay_' + label + result);
    },

    trackCheckoutEvent(action, label) {
        trackingUtils.trackEventWithCategory(
            'my_area_trips_details',
            action,
            label);
    },

    requestErrorHandler: function(response) {
        this.trackPage('confirmation_error');
        Odigeo.trigger(this.id + ':purchaseError', 'seats', response);
    },

    selectAncillariesAndAddToShoppingBasket() {
        postBookingUtils.selectAncillariesAndAddToShoppingBasket(
            this.view.oneClickCheckoutContainer,
            this.model.getBookingId(),
            this.buildAncillarySelectionList(postBookingSeatsCollection),
            'productIds.SEAT',
            this.showFailure.bind(this)
        );
    },
};
